module.exports = __webpack_public_path__ + "static/2-4ac8d32aa95c457996109b428fdadd1e.jpg";